export default "__VITE_ASSET__6462ad6a__"